import { Grid, GridProps } from "@mui/material";
import omit from "lodash/omit";

const RouteStopContainer = (props: GridProps & {
  hidden?: boolean;
}) => {
  return (
    <Grid
      container
      direction="row"
      alignItems="flex-start"
      sx={{
        userSelect: "none",
        cursor: "grab",
        margin: "0.25rem 0",
        padding: "0.5rem",
        backgroundColor: "",
        borderRadius: "0.5rem",
        opacity: props.hidden ? 0.4 : 1,
        ...props.sx,
      }}
      {...omit(props, "sx")}
    />
  );
};

export default RouteStopContainer;
